import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = {
    key: 0,
    class: "form-menu"
};
const _hoisted_4 = { class: "float-end" };
const _hoisted_5 = { class: "form-contents" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "clearfix" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_9 = { class: "input-group top_search" };
const _hoisted_10 = { class: "input-group-btn" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-5" };
const _hoisted_12 = { class: "input-group top_search" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_14 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_15 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_16 = { class: "float-end left5" };
const _hoisted_17 = { class: "clearfix pad10" };
const _hoisted_18 = { class: "float-end" };
const _hoisted_19 = {
    key: 0,
    class: "float-end"
};
const _hoisted_20 = { class: "float-end hidden-xs record-count" };
const _hoisted_21 = { class: "col-xs-12 col-sm-12" };
const _hoisted_22 = { class: "card bg-white data-grid alarm-types-grid detached overflow-x-auto" };
const _hoisted_23 = { class: "table table-hover bottom0 pw100" };
const _hoisted_24 = {
    key: 0,
    class: "text-center hidden-sm w40 no-min-width"
};
const _hoisted_25 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_26 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_27 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_28 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_29 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_30 = {
    key: 6,
    class: "hidden-sm"
};
const _hoisted_31 = { class: "text-center hidden-sm" };
const _hoisted_32 = { key: 0 };
const _hoisted_33 = { class: "clearfix visible-sm" };
const _hoisted_34 = { class: "clearfix" };
const _hoisted_35 = {
    key: 0,
    class: "fa fa-check green",
    "aria-hidden": "true"
};
const _hoisted_36 = {
    key: 1,
    class: "fa fa-times red",
    "aria-hidden": "true"
};
const _hoisted_37 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_38 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_39 = {
    key: 0,
    class: "fa fa-check green",
    "aria-hidden": "true"
};
const _hoisted_40 = {
    key: 1,
    class: "fa fa-times red",
    "aria-hidden": "true"
};
const _hoisted_41 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_42 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_43 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_44 = ["title"];
const _hoisted_45 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_dropdown_form = _resolveComponent("b-dropdown-form");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_button_group = _resolveComponent("b-button-group");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tEvent Types\r\n\t\t\t\t")
            ], -1 /* CACHED */)),
            _cache[7] || (_cache[7] = _createTextVNode()),
            (_ctx.query.companyId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_router_link, {
                            to: { name: 'event-type', params: { 'companyId': _ctx.query.companyId } }
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_b_button, { variant: "primary" }, {
                                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                            _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                            _createElementVNode("span", { class: "hidden-xs" }, " Add Event Type", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"])
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _cache[53] || (_cache[53] = _createTextVNode()),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _cache[9] || (_cache[9] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_10, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, [...(_cache[8] || (_cache[8] = [
                                        _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                    ]))])
                            ])
                        ])
                    ]),
                    _cache[22] || (_cache[22] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.company,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.company) = $event)),
                                options: _ctx.companies,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "Select a Company",
                                class: "multiselect-small"
                            }, {
                                noResult: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ])
                    ]),
                    _cache[23] || (_cache[23] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_13, [
                        (_ctx.searchAttempted)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createVNode(_component_b_dropdown, {
                                            ref: "columnSettingsDropdown",
                                            "no-caret": "",
                                            end: "",
                                            sm: "",
                                            "auto-close": false,
                                            variant: "outline-secondary outline-secondary-pagination",
                                            disabled: _ctx.working
                                        }, {
                                            "button-content": _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                    _createElementVNode("i", { class: "fa fa-cog" }, null, -1 /* CACHED */)
                                                ]))]),
                                            default: _withCtx(() => [
                                                _cache[17] || (_cache[17] = _createTextVNode()),
                                                _createVNode(_component_b_dropdown_form, { class: "column-settings-dropdown" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_b_form_group, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_b_form_checkbox, {
                                                                    id: "includeDeleted",
                                                                    modelValue: _ctx.query.includeDeleted,
                                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.includeDeleted) = $event))
                                                                }, {
                                                                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                        ]))]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["modelValue"])
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }),
                                                        _cache[13] || (_cache[13] = _createTextVNode()),
                                                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "clearfix top10" }, [
                                                            _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tColumn visibility\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                        ], -1 /* CACHED */)),
                                                        _cache[15] || (_cache[15] = _createTextVNode()),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, columnIdx) => {
                                                            return (_openBlock(), _createBlock(_component_b_form_group, {
                                                                key: column.fieldName
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_b_form_group, null, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_b_form_checkbox, {
                                                                                id: column.fieldName,
                                                                                modelValue: column.visible,
                                                                                "onUpdate:modelValue": ($event) => ((column.visible) = $event)
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                                                                                ]),
                                                                                _: 2 /* DYNAMIC */
                                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }),
                                                _cache[18] || (_cache[18] = _createTextVNode()),
                                                _createVNode(_component_b_dropdown_divider),
                                                _cache[19] || (_cache[19] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("div", _hoisted_18, [
                                                        _createVNode(_component_b_button, {
                                                            variant: "secondary",
                                                            right: "",
                                                            sm: "",
                                                            onClick: _ctx.closeColumnSettingsMenu
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                                    _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                                                    _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                ]))]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["onClick"])
                                                    ])
                                                ])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disabled"])
                                    ]),
                                    _cache[20] || (_cache[20] = _createTextVNode()),
                                    (_ctx.numberOfVisibleColumns)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            _createVNode(_component_b_pagination, {
                                                class: "float-end",
                                                modelValue: _ctx.query.pageNo,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.query.pageNo) = $event)),
                                                "per-page": _ctx.query.pageSize,
                                                "total-rows": _ctx.data.recordCount,
                                                "hide-ellipsis": true,
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[21] || (_cache[21] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_20, "\r\n\t\t\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _cache[52] || (_cache[52] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("table", _hoisted_23, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    (_ctx.isVisible('EventTypeName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_24))
                                        : _createCommentVNode("v-if", true),
                                    _cache[24] || (_cache[24] = _createTextVNode()),
                                    _createElementVNode("th", null, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'EventTypeName', title: 'Name' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _cache[25] || (_cache[25] = _createTextVNode()),
                                    (_ctx.isVisible('ScopeName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_25, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'ScopeName', title: 'Scope' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[26] || (_cache[26] = _createTextVNode()),
                                    (_ctx.isVisible('Enabled'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_26, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'Enabled', title: 'Enabled' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[27] || (_cache[27] = _createTextVNode()),
                                    (_ctx.isVisible('AlarmDefinitionsCount'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_27, "\r\n\t\t\t\t\t\t\t\t\t\t# Alarm Definitions\r\n\t\t\t\t\t\t\t\t\t"))
                                        : _createCommentVNode("v-if", true),
                                    _cache[28] || (_cache[28] = _createTextVNode()),
                                    (_ctx.isVisible('TimeWindowMinutes'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_28, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'TimeWindowMinutes', title: 'Time Window (min.)' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[29] || (_cache[29] = _createTextVNode()),
                                    (_ctx.isVisible('SendNotificationsOnFirstAlarm'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_29, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'SendNotificationsOnFirstAlarm', title: 'Notifications' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[30] || (_cache[30] = _createTextVNode()),
                                    (_ctx.isVisible('ContactNames'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_30, "\r\n\t\t\t\t\t\t\t\t\t\tContacts\r\n\t\t\t\t\t\t\t\t\t"))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _cache[50] || (_cache[50] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    var _a, _b;
                                    return (_openBlock(), _createElementBlock("tr", {
                                        class: _normalizeClass({ 'deleted': item.whenDeleted })
                                    }, [
                                        _createElementVNode("td", _hoisted_31, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm",
                                                        onClick: ($event) => (_ctx.edit(item))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                                                        _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]),
                                                            _cache[34] || (_cache[34] = _createTextVNode()),
                                                            _createVNode(_component_b_dropdown_divider),
                                                            _cache[35] || (_cache[35] = _createTextVNode()),
                                                            _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.archive(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                                                        _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]), [
                                                                [_vShow, !item.whenDeleted]
                                                            ]),
                                                            _cache[36] || (_cache[36] = _createTextVNode()),
                                                            _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.restore(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                                                        _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]), [
                                                                [_vShow, item.whenDeleted]
                                                            ])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _cache[42] || (_cache[42] = _createTextVNode()),
                                        (_ctx.isVisible('EventTypeName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'event-type', params: { 'companyId': _ctx.query.companyId, 'id': item.eventTypeId } },
                                                    class: "blue hidden-sm"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.eventTypeName), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                _cache[41] || (_cache[41] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_33, [
                                                    _createVNode(_component_router_link, {
                                                        to: { name: 'event-type', params: { 'companyId': _ctx.query.companyId, 'id': item.eventTypeId } },
                                                        class: "lead"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(item.eventTypeName), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                    _cache[40] || (_cache[40] = _createTextVNode()),
                                                    _createElementVNode("div", _hoisted_34, [
                                                        _withDirectives(_createElementVNode("div", { class: "clearfix" }, _toDisplayString(item.scopeName), 513 /* TEXT, NEED_PATCH */), [
                                                            [_vShow, item.scopeName]
                                                        ]),
                                                        _cache[38] || (_cache[38] = _createTextVNode()),
                                                        _withDirectives(_createElementVNode("div", null, _toDisplayString(item.TimeWindowMinutes), 513 /* TEXT, NEED_PATCH */), [
                                                            [_vShow, item.TimeWindowMinutes]
                                                        ]),
                                                        _cache[39] || (_cache[39] = _createTextVNode()),
                                                        _withDirectives(_createElementVNode("div", null, [
                                                            _cache[37] || (_cache[37] = _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tEnabled:\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                            (item.enabled)
                                                                ? (_openBlock(), _createElementBlock("i", _hoisted_35))
                                                                : (_openBlock(), _createElementBlock("i", _hoisted_36))
                                                        ], 512 /* NEED_PATCH */), [
                                                            [_vShow, item.Enabled]
                                                        ])
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[43] || (_cache[43] = _createTextVNode()),
                                        (_ctx.isVisible('ScopeName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_37, _toDisplayString(item.scopeName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[44] || (_cache[44] = _createTextVNode()),
                                        (_ctx.isVisible('Enabled'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_38, [
                                                (item.enabled)
                                                    ? (_openBlock(), _createElementBlock("i", _hoisted_39))
                                                    : (_openBlock(), _createElementBlock("i", _hoisted_40))
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[45] || (_cache[45] = _createTextVNode()),
                                        (_ctx.isVisible('AlarmDefinitionsCount'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_41, _toDisplayString((_b = (_a = item.alarmDefinitionIds) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : '0'), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[46] || (_cache[46] = _createTextVNode()),
                                        (_ctx.isVisible('TimeWindowMinutes'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_42, _toDisplayString(item.timeWindowMinutes), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[47] || (_cache[47] = _createTextVNode()),
                                        (_ctx.isVisible('SendNotificationsOnFirstAlarm'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(_ctx.getNotificationText(item)), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _cache[48] || (_cache[48] = _createTextVNode()),
                                        (_ctx.isVisible('ContactNames'))
                                            ? (_openBlock(), _createElementBlock("td", {
                                                key: 6,
                                                class: "large-text-ellipsis hidden-sm",
                                                title: _ctx.getContactNamesTitle(item)
                                            }, _toDisplayString(_ctx.getContactNames(item)), 9 /* TEXT, PROPS */, _hoisted_44))
                                            : _createCommentVNode("v-if", true)
                                    ], 2 /* CLASS */));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _cache[51] || (_cache[51] = _createTextVNode()),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [...(_cache[49] || (_cache[49] = [
                                            _createElementVNode("td", {
                                                class: "text-center",
                                                colspan: "9"
                                            }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */)
                                        ]))]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ])
    ]));
}
